import { Modal, Box, Avatar, Button, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import Settings from '@mui/icons-material/Settings';
import useSettingsModalStyles from './useSettingsModalStyles';
import useGlobalStyles from '../../useGlobalStyles';
import useLayoutStyles from '../../layout/useLayoutStyles';
import ProfilePictureSelector from '../../createAccount/profilePictureSelector';
import useSettingsModal from '../../../hooks/useSettingsModal';

const SettingsModal = () => {
  const { classes } = useSettingsModalStyles();
  const { classes: layoutClasses } = useLayoutStyles();
  const { classes: globalClasses } = useGlobalStyles();

  const {
    open,
    handleOpen,
    handleClose,
    usernameEdit,
    setUsernameEdit,
    username,
    handleUsernameChange,
    passwordEdit,
    setPasswordEdit,
    password,
    handlePasswordChange,
    profilePictureEdit,
    setProfilePictureEdit,
    profilePicture,
    handleProfileSelect,
    handleSubmit,
    handleDeleteAccount,
    error,
    resetError,
  } = useSettingsModal();

  return (
    <>
      <Settings className={classes.settings} onClick={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'>
        <Box className={globalClasses.modal}>
          <div className={globalClasses.modalHeader}>
            <div className={layoutClasses.boldTitle}>Settings</div>
            <CloseIcon className={globalClasses.closeButton} onClick={handleClose} />
          </div>
          <div className={classes.settingsContent}>
            <div className={classes.userInfoSettings}>
              <div className={classes.entryErrorSettings}>
                <div className={classes.entrySettings}>
                  <div className={globalClasses.h6}>Profile Picture:</div>
                  {profilePictureEdit ? (
                    <ProfilePictureSelector
                      selectedPicture={profilePicture || 'profile1.png'}
                      onSelectPicture={handleProfileSelect}
                    />
                  ) : (
                    <Avatar
                      alt='Profile Picture'
                      src={`${process.env.PUBLIC_URL}/assets/profiles/${profilePicture}`}
                      className={classes.avatar}
                    />
                  )}
                  <Tooltip
                    classes={{ tooltip: globalClasses.tooltip }}
                    PopperProps={{
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, -5],
                          },
                        },
                      ],
                    }}
                    title='Edit profile picture'
                    placement='top-start'>
                    <EditIcon
                      className={classes.editIcon}
                      onClick={() => {
                        setProfilePictureEdit(!profilePictureEdit);
                        resetError();
                      }}
                    />
                  </Tooltip>
                </div>
                {error.profilePicture && <p className={classes.error}>{error.profilePicture}</p>}
              </div>
              <div className={classes.entryErrorSettings}>
                <div className={classes.entrySettings}>
                  <div className={globalClasses.h6}>Username:</div>
                  {usernameEdit ? (
                    <input
                      type='text'
                      className={`${globalClasses.input} ${classes.input}`}
                      value={username}
                      onChange={handleUsernameChange}
                      autoFocus
                    />
                  ) : (
                    <div className={globalClasses.h6}>{username}</div>
                  )}
                  <Tooltip
                    classes={{ tooltip: globalClasses.tooltip }}
                    PopperProps={{
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, -5],
                          },
                        },
                      ],
                    }}
                    title='Edit username'
                    placement='top-start'>
                    <EditIcon
                      className={classes.editIcon}
                      onClick={() => {
                        setUsernameEdit(!usernameEdit);
                        resetError();
                      }}
                    />
                  </Tooltip>
                </div>
                {error.username && <p className={classes.error}>{error.username}</p>}
              </div>
              <div className={classes.entryErrorSettings}>
                <div className={classes.entrySettings}>
                  <div className={globalClasses.h6}>Password:</div>
                  {passwordEdit ? (
                    <input
                      type='password'
                      className={`${globalClasses.input} ${classes.input}`}
                      value={password}
                      onChange={handlePasswordChange}
                      autoFocus
                    />
                  ) : (
                    <div className={globalClasses.h6}>**************</div>
                  )}
                  <Tooltip
                    classes={{ tooltip: globalClasses.tooltip }}
                    PopperProps={{
                      modifiers: [
                        {
                          name: 'offset',
                          options: {
                            offset: [0, -5],
                          },
                        },
                      ],
                    }}
                    title='Edit password'
                    placement='top-start'>
                    <EditIcon
                      className={classes.editIcon}
                      onClick={() => {
                        setPasswordEdit(!passwordEdit);
                        resetError();
                      }}
                    />
                  </Tooltip>
                </div>
                {error.password && <p className={classes.error}>{error.password}</p>}
              </div>
            </div>
            <div className={classes.entryErrorSettings}>
              <div className={classes.buttonOptions}>
                <Button
                  onClick={handleSubmit}
                  className={`${globalClasses.button} ${classes.applyChangesButton}`}>
                  Apply Changes
                </Button>
                <Button
                  onClick={handleDeleteAccount}
                  className={`${globalClasses.button} ${classes.deleteAccountButton}`}>
                  Delete Account
                </Button>
              </div>
              {error.deleteAccount && <p className={classes.error}>{error.deleteAccount}</p>}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default SettingsModal;
